import extractYoutubeId from '@utils/video/extractYoutubeId'

// https://img.youtube.com/vi/:id/0.jpg
// https://img.youtube.com/vi/mARPGPmGOT4/0.jpg
// https://youtu.be/mARPGPmGOT4

const URL = 'https://img.youtube.com/vi'
const FORMAT = '.jpg'

export default function makeYoutubeThumbnailResolver (youtubeLink, size = '0') {
    return function fallbackResolver () {
        if (youtubeLink) {
            const id = extractYoutubeId(youtubeLink)
            if (id) return `${URL}/${id}/${size}${FORMAT}`
        }
    }
}